export function initArticleTables(root = document) {
  root.querySelectorAll('.job-post-sec__article table').forEach((table) => {
    const columns = Array.from(table.rows).reduce((maximum, row) => Math.max(
      maximum,
      Array.from(row.cells).reduce((total, cell) => total + cell.colSpan, 0),
    ), 0);
    if (columns < 4 || table.parentElement.classList.contains('job-post-sec__table-scroll')) return;

    const wrapper = table.ownerDocument.createElement('div');
    wrapper.className = 'job-post-sec__table-scroll';
    wrapper.setAttribute('tabindex', '0');
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Scrollable table');
    table.classList.add('job-post-sec__wide-table');
    table.style.setProperty('--article-table-min-width', `${columns * 140}px`);
    table.before(wrapper);
    wrapper.append(table);
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initArticleTables());
  } else {
    initArticleTables();
  }
}
